import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-selecao-clientes',
  templateUrl: './selecao-clientes.component.html',
})
export class SelecaoClientesComponent {
  @Input() SITE: any;
  @Input() pedido: any;
  @Input() pedidoClienteSelected: any;
  @Input() showTodos: boolean;
  @Input() isReadOnly: boolean;
  @Input() changePedidoClienteSelectedTodos!: () => void;
  @Input() changePedidoClienteSelected!: () => void;
  @Input() getLinkAprovaCliente!: (id: number) => void;


//   changePedidoClienteSelected() {
//     this.pedidoClienteSelected.todos = true;
//     for (let i = 0; i < this.pedido.clientes.length; i++) {
//       if (!this.pedidoClienteSelected[this.pedido.clientes[i].cliente.id]) {
//         this.pedidoClienteSelected.todos = false;
//         break;
//       }
//     }
//   }

//   changePedidoClienteSelectedTodos() {
//     this.pedido.clientes.forEach(
//       (pc) => (this.pedidoClienteSelected[pc.cliente.id] = this.pedidoClienteSelected.todos)
//     );
//   }

//   getLinkAprovaCliente(id: number) {
//     // lógica já existente no seu componente pai
//   }
}
